angular.module('dpw.services')
    .factory('user', [
        'api', 'tmhDynamicLocale', 'firstTimeLogin', 'helpers', 'defaultCountryId', 'dpwStorage', 'freeTierService', 'partnerBrands',
        function (api, tmhDynamicLocale, firstTimeLogin, helpers, defaultCountryId, dpwStorage, freeTierService, partnerBrands) {
            var user = null;
            var fetchPromise = null;
            return {
                fetch: function () {
                    if (fetchPromise == null) {
                        fetchUser();
                    }
                    return fetchPromise;
                },
                getUser: function () {
                    return user || {};
                },
                forceFetch: function () {
                    fetchUser();
                    return fetchPromise;
                },
                process: process
            };

            function fetchUser() {
                fetchPromise = api.call(api.getUserInfo(), function (data) {
                    user = data.user || {};
                    if (RCDPW.isLogin === true && _.isEmpty(user)) {
                        $.removeCookie('IS_LOGIN', { path: '/' });
                        window.location.reload();
                        return;
                    }
                    dpwStorage.setItem('brandId', _.get(user, 'brand.id', RCDPW.Lang.Brands.DefaultBrand));
                    dpwStorage.setItem('countryId', _.get(user, 'countryId', defaultCountryId));

                    var locale = angular.lowercase(user.locale);
                    locale && tmhDynamicLocale.set(locale);
                    user = process(user);
                });
            }

            function process(user) {
                if (user.brand) {
                    var partnerBrandIDs = partnerBrands.map(function (item) {
                        return item.id;
                    });
                    user.isPartner = _.includes(partnerBrandIDs, String(user.brand.id));
                }

                user.isFreeTier = freeTierService.isFreeAccount(user);

                return user;
            }
        }
    ]);
